import merge from 'lodash/merge'

export const createMockCreator = <T>(defaults: Partial<T>, mutator?: (arg: Partial<T>) => Partial<T>) => {
  const newDefault = mutator ? mutator(defaults) : defaults
  return (overrides?: Partial<T>) => merge(newDefault, overrides)
}
